import { produce } from 'immer';
import {
    EMAIL_ADDRESS_ALREADY_TAKEN,
    EMAIL_DOMAIN_NOT_AUTHORIZED,
    USERNAME_ALREADY_TAKEN
} from 'app/store/__generated__/errors';
import { extractError, extractErrorName } from 'app/lib/error';
import { FetchStatus } from 'app/lib/constants';
import {
    CREATE_USER,
    UPDATE_USER,
    OPEN_USER_CONFIGURATION_DIALOG,
    CLOSE_USER_CONFIGURATION_DIALOG,
    LIST_API_KEYS,
    REVOKE_API_KEY,
    CREATE_API_KEY,
    CLEAR_API_KEY,
    OPEN_TRANSFER_OWNERSHIP_DIALOG,
    CLOSE_TRANSFER_OWNERSHIP_DIALOG,
    LIST_USER_PROJECTS,
    TRANSFER_PROJECT_OWNERSHIP
} from './types.js';

export const INITIAL_STATE = {
    userConfiguration: null,
    isTransferOwnershipDialogOpen: false,
    error: null,
    isLoading: false,
    apiKeys: {
        isLoading: false,
        isRevoking: false,
        createStatus: FetchStatus.IDLE,
        createResult: null,
        entries: []
    }
};

export const adminReducer = produce((draft, action) => {
    switch (action.type) {
        case CREATE_USER.STARTED:
            draft.isLoading = true;
            break;

        case CREATE_USER.FAILED:
        case UPDATE_USER.FAILED: {
            const error = extractError(action.payload);
            const errorName = extractErrorName(error);
            switch (errorName) {
                case EMAIL_ADDRESS_ALREADY_TAKEN:
                case EMAIL_DOMAIN_NOT_AUTHORIZED:
                    error._field = 'email';
                    break;
                case USERNAME_ALREADY_TAKEN:
                    error._field = 'username';
                    break;
                default:
                    break;
            }
            draft.error = error;
            draft.isLoading = false;
            break;
        }
        case CREATE_USER.SUCCEEDED:
        case UPDATE_USER.SUCCEEDED:
        case CLOSE_USER_CONFIGURATION_DIALOG:
            draft.userConfiguration = null;
            draft.error = null;
            draft.isLoading = false;
            break;
        case OPEN_USER_CONFIGURATION_DIALOG:
            draft.userConfiguration = action.payload ?? {};
            break;

        case OPEN_TRANSFER_OWNERSHIP_DIALOG:
            draft.isTransferOwnershipDialogOpen = true;
            break;
        case CLOSE_TRANSFER_OWNERSHIP_DIALOG:
            draft.isTransferOwnershipDialogOpen = false;
            draft.userProjects = [];
            break;

        case LIST_API_KEYS.STARTED:
            draft.apiKeys.isLoading = true;
            break;
        case LIST_API_KEYS.SUCCEEDED:
            draft.apiKeys.entries = action.payload.entries;
            break;
        case LIST_API_KEYS.ENDED:
            draft.apiKeys.isLoading = false;
            break;

        case CREATE_API_KEY.STARTED:
            draft.apiKeys.createStatus = FetchStatus.FETCHING;
            draft.apiKeys.createResult = null;
            break;
        case CREATE_API_KEY.SUCCEEDED:
            draft.apiKeys.createStatus = FetchStatus.SUCCEEDED;
            draft.apiKeys.createResult = action.payload.key;
            break;
        case CREATE_API_KEY.FAILED:
            draft.apiKeys.createStatus = FetchStatus.FAILED;
            draft.apiKeys.createResult = extractError(action.payload);
            break;

        case CLEAR_API_KEY:
            draft.apiKeys.createStatus = FetchStatus.IDLE;
            draft.apiKeys.createResult = null;
            break;

        case REVOKE_API_KEY.STARTED:
            draft.apiKeys.isRevoking = true;
            break;
        case REVOKE_API_KEY.ENDED:
            draft.apiKeys.isRevoking = false;
            break;

        case LIST_USER_PROJECTS.STARTED:
            draft.userProjects = [];
            draft.error = null;
            draft.isLoading = true;
            break;
        case LIST_USER_PROJECTS.SUCCEEDED:
            draft.userProjects = action.payload.results;
            break;
        case LIST_USER_PROJECTS.FAILED:
            draft.error = extractError(action.payload);
            break;
        case LIST_USER_PROJECTS.ENDED:
            draft.isLoading = false;
            break;

        case TRANSFER_PROJECT_OWNERSHIP.STARTED:
            draft.isLoading = true;
            break;
        case TRANSFER_PROJECT_OWNERSHIP.SUCCEEDED:
            draft.isTransferOwnershipDialogOpen = false;
            draft.userProjects = [];
            break;
        case TRANSFER_PROJECT_OWNERSHIP.FAILED:
            draft.error = extractError(action.payload);
            break;
        case TRANSFER_PROJECT_OWNERSHIP.ENDED:
            draft.isLoading = false;
            break;

        default:
    }
}, INITIAL_STATE);
